import { useAuthContext } from 'context/AuthContext/AuthContext';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export function Logout() {
  const { logout } = useAuthContext();
  useEffect(() => {
    logout();
  }, [logout]);
  return <div />;
}
